import intensiveCareExceptionalCircumstances from '../ExceptionalCircumstances/intensiveCareExceptionalCircumstances';
import { ActCode } from './ActCode';
import { RequiredDetails } from '../requiredDetail.type';
import dateHospitalisation from 'app/codeSpecificLogic/requiredDetails/DateHospitalisation/dateHospitalisation';
import referenceProfessional from 'app/codeSpecificLogic/requiredDetails/ReferenceProfessional/referenceProfessional';

export default class ActCode15389 implements ActCode {
  // eslint-disable-next-line no-unused-vars
  constructor(private act: any) {}

  getRequiredDetails(): RequiredDetails {
    return [dateHospitalisation, referenceProfessional, intensiveCareExceptionalCircumstances];
  }
}
